'use client'

import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface TariffsModalContextType {
    showTariffs: boolean;
    openTariffs: () => void;
    openTariffsFromMenu: () => void;
    closeTariffs: () => void;
}

const TariffsModalContext = createContext<TariffsModalContextType | undefined>(undefined);

export function TariffsModalProvider({ children }: { children: ReactNode }) {
    const [showTariffs, setShowTariffs] = useState(false);

    // Автопоказ при включении READONLY — всегда открывает
    const openTariffs = useCallback(() => {
        setShowTariffs(true);
    }, []);

    // Клик по ConnectionStatus / Badge — всегда открывает
    const openTariffsFromMenu = useCallback(() => {
        setShowTariffs(true);
    }, []);

    const closeTariffs = useCallback(() => setShowTariffs(false), []);

    return (
        <TariffsModalContext.Provider value={{ showTariffs, openTariffs, openTariffsFromMenu, closeTariffs }}>
            {children}
        </TariffsModalContext.Provider>
    );
}

export function useTariffsModal() {
    const context = useContext(TariffsModalContext);
    if (context === undefined) {
        throw new Error('useTariffsModal must be used within a TariffsModalProvider');
    }
    return context;
}